<template>
    <div>
        <el-select
            :value="valorAtual"
            filterable clearable
            placeholder="Selecione o conceito (escala de valores)"
            @change="onChange"
            style="max-width: 500px;">
            <el-option
                v-for="c in conceitos"
                :key="c.id"
                :label="rotulo(c)"
                :value="c.id">
            </el-option>
        </el-select>
        <div v-if="conceitoSelecionado" style="color: #909399; font-size: 12px; margin-top: 6px;">
            Valores: {{ (conceitoSelecionado.itens || []).map(i => i.l).join(', ') || '—' }}
        </div>
    </div>
</template>

<script>
// Editor do parâmetro avaliacao.conceito_id — escolhe qual Conceito fornece a escala
// (itens {v,l}) usada no lançamento por conceito. Carrega a lista de api/conceito/getAll.
export default {
    name: 'ConceitoEscalaEditor',
    props: {
        p: { type: Object, required: true },
        valor: { default: null }
    },
    data () {
        return { conceitos: [] }
    },
    computed: {
        valorAtual () {
            const n = parseInt(this.valor)
            return isNaN(n) ? '' : n
        },
        conceitoSelecionado () {
            return this.conceitos.find(c => c.id === this.valorAtual) || null
        }
    },
    mounted () { this.carregar() },
    methods: {
        carregar () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/conceito/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.conceitos = r.data || []
            }).catch(e => { this.$store.commit('throwException', e) })
        },
        rotulo (c) {
            const grupo = c.grupo ? `${c.grupo.nome} — ` : ''
            return `${grupo}${c.descricao}`
        },
        onChange (v) {
            this.$emit('save', v === '' || v === null || v === undefined ? '' : v)
        }
    }
}
</script>
